import React from 'react'
import { Switch, Route } from 'react-router-dom'
import * as routes from 'constants/routes'

import RegionsIndex from 'containers/Regions/RegionsIndex'
import RegionsCreate from 'containers/Regions/RegionsCreate'
import RegionsEdit from 'containers/Regions/RegionsEdit'
import RegionsShow from 'containers/Regions/RegionsShow'

function RegionsRoutes(props) {
  return (
    <Switch>
      <Route exact path={`${routes.REGIONS}`} component={RegionsIndex}/>
      <Route path={`${routes.REGIONS}/create`} component={RegionsCreate}/>
      <Route path={`${routes.REGIONS}/:id/show`} component={RegionsShow}/>
      <Route path={`${routes.REGIONS}/:id/edit`} component={RegionsEdit}/>
    </Switch>
  )
}

export default RegionsRoutes